import * as api from '@tytapp/api';
import { Model } from 'common';

@Model('Franchise')
export class Franchise extends api.ApiFranchise {

}